import React from 'react';
import T from 'prop-types';
import { ButtonRow, Button } from '@piggybank/core';
import { Translation } from 'srcAlias/client/locale';
export const ButtonSection = ({ continueButtonClick }) => {
  return (
    <ButtonRow>
      <Button onClick={continueButtonClick}>
        <Translation path={'startInvestingUTButton'} />
      </Button>
    </ButtonRow>
  );
};
ButtonSection.propTypes = {
  continueButtonClick: T.func,
};
